import { render, staticRenderFns } from "./salary-detail-tabs.vue?vue&type=template&id=3fa42485&scoped=true&"
import script from "./salary-detail-tabs.vue?vue&type=script&lang=js&"
export * from "./salary-detail-tabs.vue?vue&type=script&lang=js&"
import style0 from "./salary-detail-tabs.vue?vue&type=style&index=0&id=3fa42485&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa42485",
  null
  
)

export default component.exports